interface OriginTextsModelState {
  originTexts: string[]; // Replace 'any' with the appropriate type for your originTexts
}

const initialState: OriginTextsModelState = {
  originTexts: [],
};

const originTextsModel = {
  name: 'originTextsModel',
  state: initialState,
  reducers: {
    setOriginTexts(state: OriginTextsModelState, originTexts: string[]) {
      return { originTexts: [...new Set([...state.originTexts, ...originTexts])] };
    },
  },
  effects: dispatch => ({
    // Add any asynchronous side effects here if needed
  }),
};

export default originTextsModel;
